module.exports = __webpack_public_path__ + "BV.png?f24fdc2ab87cb91bddb47b2b7a667d4e";